{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Värvivalija",
  "twoDimensionalSlider": "2D-liugur",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
